import { Pagination, SuccessResponse } from "common/common.interface";
import { environment } from "common/environment";
import { Cerfat, CreateCerfatPayload } from "modules/cerfat/types/cerfat.interface";

export interface CerfatBackend {
  getAllCerfats(
    page: number,
    limit: number,
    searchName: string | undefined
  ): Promise<Pagination<Cerfat>>;
  getCerfat(id: string): Promise<Cerfat>;
  createCerfat(payload: CreateCerfatPayload): Promise<SuccessResponse>;
  updateCerfat(id: string, payload: CreateCerfatPayload): Promise<SuccessResponse>;
  downloadCerfa(id: string): Promise<ArrayBuffer>;
  generateDocuments(ids: string[]): Promise<SuccessResponse>;
}

let cerfatBackendInstance: CerfatBackend | undefined;

export async function getCerfatBackend(): Promise<CerfatBackend> {
  if (cerfatBackendInstance === undefined) {
    const mod = await import(`./${environment.CERFAT_BACKEND}`);
    cerfatBackendInstance = new mod.default() as CerfatBackend;
  }
  return cerfatBackendInstance;
}
